<template>
<div id="app">
  <Forum v-if="$route.query.showforum" />
  <Thread v-else-if="$route.query.showtopic || ($route.query.act && $route.query.act.toUpperCase() == 'ST')" />
  <Members v-else-if="$route.query.act && $route.query.act == 'Members'" />
  <GetPM v-else-if="$route.query.act && $route.query.act == 'Msg' && $route.query.MSID" />
  <PMs v-else-if="$route.query.act && $route.query.act == 'Msg'" />
  <Warnings v-else-if="$route.query.act && $route.query.act == 'warn' && $route.query.mid" />
  <Profile v-else-if="$route.query.showuser" />
  <FindPost v-else-if="$route.query.view && $route.query.view.toUpperCase() == 'FINDPOST' && $route.query.p" />
  <AllForums v-else />
</div>
</template>

<script>
import Forum from './components/Forum'
import AllForums from './components/AllForums'
import Thread from './components/Thread'
import Members from './components/Members'
import PMs from './components/PMs'
import GetPM from './components/GetPM'
import Profile from './components/Profile'
import Warnings from './components/Warnings'
import FindPost from './components/FindPost'

export default {
  components: {
    Forum,
    AllForums,
    Thread,
    Members,
    PMs,
    GetPM,
    Profile,
    Warnings,
    FindPost
  }
}
</script>

<style lang="scss">
@import "./App.scss";
</style>
